import React, {
  ChangeEvent, FC, useState, ReactNode, useEffect
} from 'react';
import styles from './checkboxComponent.module.css';

type PropsType = {
  title?: string | ReactNode;
  name?: string;
  defaultValue: boolean;
  onChange: (checkedValue: boolean) => void;
};

const CheckboxComponent: FC<PropsType> = ({
  title,
  name = 'checkbox',
  defaultValue,
  onChange = () => {},
}) => {
  const [checked, setChecked] = useState(defaultValue);

  useEffect(() => {
    setChecked(defaultValue);
  }, [defaultValue]);

  const onToggleCheckbox = (e: ChangeEvent<HTMLInputElement>) => {
    setChecked(e.currentTarget.checked);
    onChange(e.currentTarget.checked);
  };

  return (
        <label className={styles.label} htmlFor={name}>
            {title}
            <input id={name} name={name} type="checkbox" onChange={onToggleCheckbox} checked={checked} />
        </label>
  );
};

export default CheckboxComponent;
